// eslint-disable-next-line @typescript-eslint/no-explicit-any
const component = () => null;
export const NoopModal = component;
//# sourceMappingURL=NoopModal.js.map